export default __webpack_public_path__ + "static/media/krishna-veer.99359943.jpg";